import React, { FC, useEffect, useState } from "react";
import { Logo } from "kanopi-components/Logo";
import { useThemeContext } from "kw/themeContext";

export type TBrandLogo = {
  src: string;
  altText?: string;
};
export const BrandLogo: FC = () => {
  const { context } = useThemeContext();
  const [logo, setLogo] = useState<TBrandLogo>();
  useEffect(() => {
    setLogo(context?.logo);
  }, [context?.logo]);
  return <Logo src={logo?.src} altText={logo?.altText} />;
};
